var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageViewerContainer"},[_c('img',{staticClass:"ImageViewer",attrs:{"src":_vm.imageData}})])
}
var staticRenderFns = []

export { render, staticRenderFns }